import React, { useContext, useEffect, useRef, useState } from "react";
import "./style.css";
import withUser from "../../redux/HOC/withUser";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { SigninApi } from "../../utils/API";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { constants, messages } from "../../common/constants";
import swal from "sweetalert";
import { BroadcastChannel } from "broadcast-channel";
import _ from "lodash";
import { hasAccess } from "../../common/commonFunctions";
import { pageConstant } from "../../config/pageConstant";

const Login = ({ setUser }: any) => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorDisplay, setErrorDisplay] = useState(false);
  const [loderOnSingin, setLoderOnSingin] = useState(false);
  const [authenticated, setauthenticated] = useState(false);
  const logoutChannel = new BroadcastChannel("logout-channel");

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

  const onClickNavigate = (page: string) => {
    navigate(`${page}`);
  };

  const CloseError = () => {
    setErrorDisplay(false);
  };

  const onSignIn = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    setLoderOnSingin(true);
    let hasError = true;

    if (userName === "") {
      setErrorDisplay(true);
      hasError = false;
    } else {
      setErrorDisplay(false);
    }
    if (password === "") {
      setErrorDisplay(true);

      hasError = false;
    } else {
      setErrorDisplay(false);
    }
    if (hasError === true) {
      setLoderOnSingin(false);
      let tempSigninObj: any = {
        username: userName,
        password: password,
      };

      let SigninApiRes: any = await SigninApi(tempSigninObj);
      try {
        if (!SigninApiRes) {
          swal({
            title: constants.Error,
            text: messages.userManagementService,
            icon: constants.swalIconError,
            dangerMode: true,
            closeOnClickOutside: false,
          });
        } else if (SigninApiRes?.status === 200) {
          window.localStorage.clear();
          setLoderOnSingin(false);
          showToast("successful");
          let SigninApiData: any = await SigninApiRes?.json();
          window.sessionStorage.setItem("username", SigninApiData.userName);
          var currentTokenExp = JSON.stringify(
            SigninApiData.expiryTimeInMsSinceEpoch
          );
          window.localStorage.setItem("username", SigninApiData.userName);
          window.localStorage.setItem(
            "refreshtoken",
            SigninApiData.accessToken
          );
          if (
            SigninApiData &&
            Array.isArray(SigninApiData?.accessDetails) &&
            SigninApiData?.accessDetails?.length > 0
          ) {
            window.localStorage.setItem(
              "activeClient",
              SigninApiData.accessDetails[0].clientName
            );
            window.localStorage.setItem(
              "activeClientShortName",
              SigninApiData.accessDetails[0].clientShortName
            );
            if (
              Array.isArray(SigninApiData?.accessDetails[0]?.accountDetails) &&
              SigninApiData?.accessDetails[0]?.accountDetails?.length > 0
            ) {
              if (
                SigninApiData.accessDetails[0]?.accountDetails[0]
                  ?.permissions &&
                _.isArray(
                  SigninApiData.accessDetails[0]?.accountDetails[0]?.permissions
                )
              ) {
                const uniquePerms = _.uniq(
                  SigninApiData.accessDetails[0]?.accountDetails[0]?.permissions
                );
                SigninApiData.accessDetails[0].accountDetails[0].permissions =
                  uniquePerms;
              }

              window.localStorage.setItem(
                "currentActiveAccount",
                JSON.stringify(
                  SigninApiData.accessDetails[0]?.accountDetails[0]
                )
              );
              window.localStorage.setItem(
                "activeAccountCode",
                SigninApiData.accessDetails[0].accountDetails[0]?.accountCode
              );
            }
          }
          window.localStorage.setItem("expiryTimeInMs", currentTokenExp);
          setauthenticated(true);
          window.localStorage.setItem("authenticated", "true");
          setUser(SigninApiData);
          const route = getRouteName();
          onClickNavigate(route);
          setUserName("");
          setPassword("");
          setTimeout(() => {
            logoutChannel.postMessage(SigninApiData.userName);
          }, 800);
        } else {
          showToastError(messages.InvalidUsername);
        }
        setUserName("");
        setPassword("");
        setLoderOnSingin(false);
      } catch (err) {
        console.log("error", err);
        showToastError(messages.InvalidUsername);
        setLoderOnSingin(false);
        setUserName("");
        setPassword("");
      }
    }
    setLoderOnSingin(false);
  };

  const showToast = (SigninApiRes: any) => {
    toast.success(SigninApiRes, {
      data: {
        title: "",
        text: "",
      },
    });
  };
  const showToastError = (SigninApiRes: any) => {
    toast.error(SigninApiRes, {
      data: {
        title: "",
        text: "",
      },
    });
  };

  const getRouteName = () => {
    const currentAccount = window.localStorage.getItem("currentActiveAccount");
    let account: any = null;

    if(currentAccount && !_.isEmpty(currentAccount)){
      account = JSON.parse(currentAccount)
    }

    const isSLDashboard = hasAccess([
      `${pageConstant?.SL_QUOTE_DASHBOARD}_ADMIN`,
      `${pageConstant?.SL_QUOTE_DASHBOARD}_RW`,
      `${pageConstant?.SL_QUOTE_DASHBOARD}_RO`,
    ]);
    const isLocateDashboard = hasAccess([
      `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
      `${pageConstant?.LOCATE_DASHBOARD}_RW`,
      `${pageConstant?.LOCATE_DASHBOARD}_RO`,
    ]);
    const isLocateClient = hasAccess([
      `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
      `${pageConstant?.LOCATE_CLIENT}_RW`,
      `${pageConstant?.LOCATE_CLIENT}_RO`,
    ]);
    let homeRoute = "/dashboards/sl-quote/MSFT";
    if (isSLDashboard) {
      homeRoute = "/dashboards/sl-quote/MSFT";
    } else if (isLocateDashboard) {
      homeRoute = "/locates/locates-dashboard";
    } else if (isLocateClient && account?.clientType === 'Locate') {
      homeRoute = "/locates/locates-client";
    }

    return homeRoute;
  };

  return (
    <div className="loginMainDiv">
      <div className="loginDiv">
        <div>
          <h2 className="loginText">SIGN IN</h2>
          <div>
            <div className="mb-3 inputFieldDivLogin">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label inputLoginLabel"
              >
                USERNAME
              </label>
              <input
                className="form-control input-style-login inputBorderNone"
                placeholder="Username"
                type="email"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>
            <div className="mb-3 inputFieldDivLogin">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label inputLoginLabel"
              >
                PASSWORD
              </label>
              <input
                className="form-control input-style-login inputBorderNone"
                placeholder="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                className="forgotPasswordDiv"
                onClick={() => onClickNavigate("/forgotpassword")}
              >
                <span className="forgotPassSpan">Forgot Password?</span>
              </div>
            </div>

            <div className="submitBtnDiv">
              <button
                type="submit"
                className="btn btn-primary submitBtnLogin"
                onClick={(e) => onSignIn(e)}
              >
                {loderOnSingin === true ? (
                  <div
                    className="spinner-border text-light spinner-border-sm"
                    role="status"
                  ></div>
                ) : (
                  "Sign In"
                )}
              </button>
            </div>
            {errorDisplay === true && (
              <div className="forgotPasswordMainDiv">
                <div className="error-style-Login">
                  Invalid username and password
                </div>
                <div className="error-style-Login-btn" onClick={CloseError}>
                  <CloseIcon style={{ fontSize: "0.8rem" }} />
                </div>
              </div>
            )}
            <div>
              <div className="signUpSpan">
                Don't have an account?
                <span
                  className="signUpDivOnclick"
                  onClick={() => onClickNavigate("/signup")}
                >
                  Sign Up
                </span>
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withUser(Login);
